<template>
    <div class="backdrop" @click.self="onCancel">
        <div class="inrange-container-dialog">
            <div style="display:flex; justify-content:center; position:relative;">
                <div>
                    Bay Activation
                </div>
                <div style="position:absolute; right:0; font-weight:bold;">Total: {{ Utilities.toCurrency(totalCost) }}</div>
            </div>
            <div style="margin-bottom:10px"><hr /></div>            
            <div style="display:flex;; flex-direction: column;height:90%;width:90%;margin:auto">

                <!-- Message -->
                <div style="margin-bottom:24px;display:flex;flex-direction: row;">
                    <div style="">
                        <label style="display:block; font-weight:bold; margin-bottom:8px; color:#3c7458;">
                            Welcome Message
                        </label>
                        <input type="text" v-model="message" style="width:400px; padding:10px; border-radius:8px; border:1px solid #a8bbaa; font-size:16px;" />
                    </div>
                    
                </div>
            
                <div style="display: flex;flex-direction: row; gap: 40px;margin-bottom:25px;" v-if="pricingModel">


                    <!-- Players -->
                    <div class="inrange-four-box-container">
                        <label class="inrange-four-box-title">
                            Select Number of Players
                        </label>
                        <select class="station-input-item-select" style="width:220px;" v-model="selectedPlayerId">
                            <option :value="-1" disabled>Select players</option>
                            <option v-for="playerKey in 4" :key="playerKey" :value="playerKey-1">{{ playerKey }}</option>
                        </select>
                    </div>

                    <!-- Duration -->
                    <div class="inrange-four-box-container">
                        <label class="inrange-four-box-title">
                            Select Duration
                        </label>
                        <select class="station-input-item-select" style="width:340px;" v-model="selectedDurationId">
                            <option :value="-1" disabled>Select duration</option>
                            <option
                                v-for="durationModel in durationsWithDetails"
                                :key="durationModel.id"
                                :value="durationModel.id"
                                :disabled="durationModel.disabled">
                                {{ durationModel.disabled
                                    ? (durationModel.name + ' — ' + (durationModel.duration > 0 ? durationModel.duration + ' minutes — ' : '') + 'Not Available')
                                    : (durationModel.name + ' — ' + durationModel.duration + ' minutes — ' + durationModel.balls + ' balls — ' + Utilities.toCurrency(durationModel.price + durationModel.tax)) }}
                            </option>
                        </select>
                    </div>
                    
                </div>

                <!-- Bays -->
                <div style="padding:8px; border-radius:12px; border:2px solid #a8bbaa; margin-bottom: 24px;">
                    <span class="inrange-four-box-title">
                        Select Bays
                    </span>

                    <div class="inrange-four-box-selector" style="overflow-y: auto;height: 470px;align-content: flex-start">
                        <label
                            v-for="bay in bays"
                            :key="bay.id"
                            style="padding:12px; border-radius:12px; border:2px solid transparent;height:75px;"
                            :style="bay.status !== 1 ? 'background:white;color:gray;borderColor:#3c7458' : (selectedBayId === bay.id ? 'cursor:pointer;background:#3c7458;color:white;borderColor:#3c7458' : 'cursor:pointer;background:white;color:#213528;borderColor:transparent')">

                            <input type="radio" name="bays" :value="bay.id" v-model="selectedBayId" style="display:none;" :disabled="bay.status !== 1"/>
                            <div style="width:120px;height:100%;display:flex;flex-direction: column;justify-content: space-between;">
                                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:6px;">
                                    <span style="font-weight:bold;">Bay {{ bay.id }}</span>
                                    <span v-if="bay.details.length"
                                        @click.stop.prevent="showDetails(bay)"
                                        title="View bay details"
                                        style="cursor:pointer; font-size:11px; font-style:italic; line-height:1; border:1px solid currentColor; border-radius:50%; width:16px; height:16px; display:flex; align-items:center; justify-content:center;">i</span>
                                </div>
                                <div v-if="bayModifierDisplay(bay.id)" style="font-size:11px; margin-bottom:4px; font-weight:bold;">{{ bayModifierDisplay(bay.id) }}</div>
                                <div style="display:inline-block; font-size:12px; padding:3px 3px; border-radius:5px; color:white;text-align: center;"
                                    :style="`background:${bay.statusColor}`">
                                    {{ bay.statusDisplay }}
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                

                <div class="inrange-button-bar">
                    <div v-if="false" class="station-input-container" style="justify-content: flex-start; gap:15px;position: absolute; left:40px">
                        <span style="margin:auto 0">Location</span>
                        <select class="station-input-item-select" v-model="siteSettingName" @change="getData" :disabled="fetchingData">
                            <option v-bind:value="'sitesetting01'">Main</option>
                            <option v-bind:value="'sitesetting02'">{{ locations.find(item => item.siteSetting === "siteSetting02")?.siteName ?? "Alt 2" }}</option>
                            <option v-bind:value="'sitesetting03'">{{ locations.find(item => item.siteSetting === "siteSetting03")?.siteName ?? "Alt 3" }}</option>
                            <option v-bind:value="'sitesetting04'">{{ locations.find(item => item.siteSetting === "siteSetting04")?.siteName ?? "Alt 4" }}</option>
                            <option v-bind:value="'sitesetting05'">{{ locations.find(item => item.siteSetting === "siteSetting05")?.siteName ?? "Alt 5" }}</option>
                            <option v-bind:value="'sitesetting06'">{{ locations.find(item => item.siteSetting === "siteSetting06")?.siteName ?? "Alt 6" }}</option>
                            <option v-bind:value="'sitesetting07'">{{ locations.find(item => item.siteSetting === "siteSetting07")?.siteName ?? "Alt 7" }}</option>
                            <option v-bind:value="'sitesetting08'">{{ locations.find(item => item.siteSetting === "siteSetting08")?.siteName ?? "Alt 8" }}</option>
                            <option v-bind:value="'sitesetting09'">{{ locations.find(item => item.siteSetting === "siteSetting09")?.siteName ?? "Alt 9" }}</option>
                            <option v-bind:value="'sitesetting10'">{{ locations.find(item => item.siteSetting === "siteSetting10")?.siteName ?? "Alt 10" }}</option>
                        </select>
                    </div>
                    <button class="administrator-button inrange-button" @click="onStart" v-if="!fetchingData && (selectedPlayerId > -1 && selectedDurationId > -1 && selectedBayId > -1)">
                        Start
                    </button>
                    <button class="administrator-button button-cancel inrange-button" style="margin-right:40px;" @click="onCancel">
                        Cancel
                    </button>
                </div>

                <div style="margin-bottom: 60px;"></div>
            </div>
        </div>

        <!-- Bay details popup: renders whatever details a device surfaced (pin today, more later) -->
        <div v-if="detailsBay" class="bay-details-backdrop" @click.self="detailsBay = null">
            <div class="bay-details-dialog">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
                    <span style="font-weight:bold; color:#3c7458;">Bay {{ detailsBay.id }} Details</span>
                    <span style="cursor:pointer; font-size:18px; line-height:1;" @click="detailsBay = null">&times;</span>
                </div>
                <hr style="margin-bottom:12px;" />
                <div v-if="detailsBay.details.length">
                    <div v-for="detail in detailsBay.details" :key="detail.key"
                        style="display:flex; justify-content:space-between; gap:24px; padding:6px 0;">
                        <span style="font-weight:bold;">{{ detail.label }}</span>
                        <span>{{ detail.value }}</span>
                    </div>
                </div>
                <div v-else style="color:gray;">No details available.</div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, getCurrentInstance, ref } from "vue";
import apiBay from "@/api/apiBay";
import Utilities from "@/common/utilities";
import apiLocation from "@/api/apiLocation";

export default {
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;

        const fetchingData = ref(false);
        const selectedBayId = ref(-1);
        const selectedDurationId = ref(-1);
        const selectedPlayerId = ref(-1);
        const bays = ref([]);
        const pricingModel = ref(null);

        // Fixed labels for the four duration tiers, indexed by row (fallback when a model has no name).
        const durationNames = ["Short", "Standard", "Long", "Extended"];
        const bayTaxRate = ref(0);
        const bayTaxInclusive = ref(false);
        const bayModifiers = ref([]);

        const getBayModifier = (bayId) => bayModifiers.value.find(m => m.bayId === bayId) || null;

        // Display string for a bay's modifier, e.g. "+$5.00", "-10%", or "" when none.
        const bayModifierDisplay = (bayId) => {
            const m = getBayModifier(bayId);
            if (!m || !m.amount) return "";
            const sign = m.amount > 0 ? "+" : "-";
            const abs = Math.abs(m.amount);
            return m.type === "percent" ? `${sign}${abs}%` : `${sign}${Utilities.toCurrency(abs)}`;
        };

        const applyBayModifier = (price, modifier) => {
            if (!modifier || !modifier.amount) return price;
            return modifier.type === "percent"
                ? price + price * (modifier.amount / 100)
                : price + modifier.amount;
        };
        const message = ref("");
        const locations = ref([])
        const siteSettingName = ref("sitesetting01")
        const detailsBay = ref(null);

        const showDetails = (bay) => {
            detailsBay.value = bay;
        };


        const getData = async () => {
            selectedBayId.value = -1
            selectedDurationId.value = -1
            selectedPlayerId.value = -1
            message.value = "Welcome"
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;

                const displayPricing = await apiBay.getDisplayPricing(siteSettingName.value);
                pricingModel.value = displayPricing.models;
                bayTaxRate.value = displayPricing.taxRate;
                bayTaxInclusive.value = displayPricing.taxInclusive || false;
                bayModifiers.value = displayPricing.bayModifiers || [];
                bays.value = await apiBay.getBayStatus(siteSettingName.value);
                if (locations.value.length == 0)
                    locations.value = await apiLocation.getAll();
                        
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };                
      
      
        const onStart = async () => {            
            try {
                emitter.emit("server-call-start", "Starting bay...");
                fetchingData.value = true;
                
                const pincodeModel = await apiBay.startBay(siteSettingName.value, selectedPlayerId.value, selectedDurationId.value, selectedBayId.value, message.value);
                emit("on-start-bay", pincodeModel)
                        
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error starting bay", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };                
        

        const durationsWithDetails = computed(() => {
            return (pricingModel.value ?? []).map(d => {
                const players = d?.players ?? []

                let player = null
                if (players.length>0) {    
                    player = players.find(p => p?.id === selectedPlayerId.value)
                }

                const balls = player?.balls ?? 0
            
                return {
                    id: d?.id ?? null,
                    name: d?.name || durationNames[d?.id] || '',
                    duration: d?.duration ?? 0,
                    price: player?.price ?? 0,
                    tax: bayTaxInclusive.value ? 0 : (player?.price ?? 0) * bayTaxRate.value,
                    balls,
                    disabled: balls <= 0 || (d?.duration ?? 0) < 1
                }
            })
        })

        // Total for the current selection: category-adjusted duration price + bay modifier + tax.
        const totalCost = computed(() => {
            const duration = (durationsWithDetails.value || []).find(d => d.id === selectedDurationId.value)
            if (!duration || selectedPlayerId.value < 0 || selectedBayId.value < 0)
                return 0

            const adjusted = applyBayModifier(duration.price, getBayModifier(selectedBayId.value))
            // Inclusive tax is already in the price; exclusive is added on top.
            return bayTaxInclusive.value ? adjusted : adjusted + (adjusted * bayTaxRate.value)
        })

        const onCancel = () => {
            emit("on-close");
            return true;
        };

        return {
            Utilities,
            onCancel,
            fetchingData,
            bays,
            selectedBayId,
            selectedDurationId,
            selectedPlayerId,
            getData,
            pricingModel,            
            durationsWithDetails,
            onStart,
            message,
            locations,
            siteSettingName,
            detailsBay,
            showDetails,
            bayModifierDisplay,
            totalCost
        };
    }
};
</script>

<style scoped>
.inrange-container-dialog {
    display: flex;
    flex-direction: column;
    position: absolute;
    top:50px;
    left: 50%;
    margin-left: -400px;
    width: 800px;
    height: 850px;
    /* height: 70%; */
    background: var(--main-background);
    border-radius: 10px;
    padding: 10px;
    border: 1px solid var(--card-body-border);
}


.inrange-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
}

.inrange-button {
    /* background-color: cornflowerblue; */
    /* color: var(--button-color); */
    padding: 10px;
    margin-right: 10px;
    width: 125px;
    /* cursor: pointer; */
}



.inrange-four-box-container {
    padding:8px; border-radius:12px; border:2px solid #a8bbaa;
}

.inrange-four-box-title {
    display:block; font-weight:bold; margin-bottom:10px; color:#3c7458;
}

.inrange-four-box-selector {
    margin-bottom:10px; gap:10px; display: flex; flex-direction: row;flex-wrap: wrap;
}

.inrange-four-box-item {
    width:120px;height:75px;display:flex;flex-direction: row;justify-content: space-between;align-items: center;flex: 0 0 calc(50% - 10px);
}

.bay-details-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.bay-details-dialog {
    background: var(--main-background);
    border: 1px solid var(--card-body-border);
    border-radius: 10px;
    padding: 20px;
    min-width: 280px;
    max-width: 400px;
    max-height: 70vh;
    overflow-y: auto;
}

</style>
